import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { StyledGrid } from '../styles';
import { Button } from '@mui/material';
import GradientCard from 'Core_Components/GradientCard/GradientCard';
import { appInsights } from 'Core_Helpers/AppInsights';
import { selectUserInfo, selectUserMeta } from 'Core_Redux/user';
import { useCoreSelector } from 'Contexts/StoreContext';
import hasPermissions from 'Core_Helpers/authentication/hasPermissions';
import filterUserMetaByTag from 'Core_Pages/MyTools/userMetaHelpers';
import urlcat from 'urlcat';
import { ToolTypes } from 'Core_Pages/MyTools/enumerations/enums';
import { MYTOOLS } from 'Core_Pages/Routes/RoutesConfig';
import { caregiving } from 'Assets/img/my-tools-icons';
import { caregivingItems } from 'Core_Pages/MyTools/MyToolsPage/MyCaregivingTools/config';

function MyCaregivingTile() {
  const history = useHistory();
  const intl = useIntl();
  const profile = useCoreSelector(selectUserInfo);
  const userMeta = useCoreSelector(selectUserMeta);
  const isAdultCaregiver = userMeta?.caregiver?.isAdultCaregiver;

  function onToolClick() {
    appInsights.trackEvent({ name: 'MyTools_Caregiving' });
    history.push(urlcat(MYTOOLS, { toolType: 'caregiving' }));
  }

  const getLessonTotal = () => {
    return caregivingItems.filter(
      (x) => hasPermissions(x.permissions, x.roles, profile) && filterUserMetaByTag(x.contentCategory, userMeta),
    )?.length;
  };

  return (
    <>
      {isAdultCaregiver && (
        <StyledGrid mobile={12} tablet={6}>
          <Button onClick={onToolClick} fullWidth sx={{ padding: '0px' }}>
            <GradientCard
              titleId="home.tools.caregiver"
              backgroundColor="#C1E0FF"
              icon={caregiving}
              to={urlcat(MYTOOLS, { toolType: 'caregiving' })}
              toolType={ToolTypes.CAREGIVING}
              imageStyle={{ margin: '22px 6px' }}
              label={`${getLessonTotal()} ${intl.formatMessage({ id: 'home.tools.label' })}`}
            />
          </Button>
        </StyledGrid>
      )}
    </>
  );
}

export default MyCaregivingTile;
